import { mapGetters, mapActions } from 'vuex'
import state, { initialState } from './state';
import getters, { getterTypes } from './getters';
import actions, { actionTypes } from './actions';
import mutations from './mutations';

// TODO: allow meta data to be added, meta:{ loaded, total, synced}

export const productsComputed = mapGetters(Object.keys(getterTypes));
export const productsMethods = mapActions(Object.keys(actionTypes));

export default {
	state: initialState(),
	getters,
	actions,
	mutations,
};
